import { INFORMATION_PATH } from 'devices/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/show/routes/information/index.js